import DefaultCL from "../../../../src/gatsby-theme-carbon/templates/DefaultCL";
import { TkFooter } from "../../../../src/components/toolkit/TkFooter";
import CheckerRuleSets from "../../../../src/components/requirements/checkerRuleSets.js";
import * as React from 'react';
export default {
  DefaultCL,
  TkFooter,
  CheckerRuleSets,
  React
};